import { PaymentRequestStatus, type PaymentRequestDetailsView } from './payment.types';

export function getPaymentRequestReminderUnavailableReason(
    paymentRequestDetailsView: PaymentRequestDetailsView
): string | null {
    if (
        paymentRequestDetailsView.status !== PaymentRequestStatus.SENT &&
        paymentRequestDetailsView.status !== PaymentRequestStatus.VIEWED &&
        paymentRequestDetailsView.status !== PaymentRequestStatus.PARTIALLY_PAID
    ) {
        return 'Only active unpaid payment requests can receive reminders.';
    }
    if (!paymentRequestDetailsView.public_payment_url) {
        return 'This payment request has no active payment link.';
    }
    if (
        paymentRequestDetailsView.expires_ts !== undefined &&
        Date.parse(paymentRequestDetailsView.expires_ts) <= Date.now()
    ) {
        return 'This payment link has expired.';
    }
    return null;
}
